module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/steps-desktop@3x-2dc21b5e2badc646f6367d18ebc93e2a.png";